import { ModelState } from './types';

export const modelStateDefaultValue: ModelState = {
  documents: '',
  details: '',
  request_id: undefined,
  appealSent: false,
  appealSentSuccessfully: false,
  isAppealSent: false,
  isApeealSentSuccess: false,
  appealSubmitError: '',
  userDocumentsList: {},
  appealType: '',
  appealDocumentsBackToFix: [],
  isChangeBankDetails: false,
  requestData: {
    adminAssignment: false,
    candidateEntering: '',
    childrenDisability: '',
    disability: [],
    exceedsStandards: { value: false, label: '' },
    note: '',
    houseHoldPeople: '',
    openUniversity: '',
    requestNumber: 0,
    parenOneIncome: '',
    parenTwoIncome: '',
    reservedField: '',
    spouse: '',
    studiesScope: '',
  },
  detailedScore: {
    tier: 0,
    income: 0,
    children: 0,
    total: 0,
    isMaster: false,
  },
  invalidDocuments: [],
  appealReturnComment: '',
  originalAppealDocuments: [],
  fixBankFile: '',
};
